import { useFeatureFlags } from "@cx-component-library/react-components/feature-flags";
import type { AppConfigFeatureFlags } from "feature-flags";
import { useAuthUser } from "hooks/authentication";
import {
  SettingsContext,
  type SettingsContextValue,
} from "providers/SettingsProvider";
import { useContext, useMemo } from "react";
import { deriveAccountType } from "service/utils/get-account-type";

/** The collection heart is for Customer Lounge and internal users, behind `collectionBookmark`. */
export const useCanBookmarkToCollection = (): boolean => {
  const [flags] = useFeatureFlags<AppConfigFeatureFlags>();
  const { settings } = useContext<SettingsContextValue>(SettingsContext);
  const { user } = useAuthUser();
  const isEligibleUser = useMemo(() => {
    const accountType = deriveAccountType(user, settings);
    return accountType === "CUSTOMER_LOUNGE" || accountType === "INTERNAL";
  }, [user, settings]);

  return flags.collectionBookmark?.enabled === true && isEligibleUser;
};
